import 'react'
import { ConfigProvider, type ConfigProviderProps } from 'antd'
import 'antd/dist/reset.css'
import { type FunctionComponent } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import MasterLayout from './components/MasterLayout'
import store from './store'

const primaryColor = '#01b6e1'

const antConfig: ConfigProviderProps = {
  theme: {
    token: {
      colorPrimary: primaryColor,
      colorLink: primaryColor,
      borderRadius: 0
    }
  },
  modal: { mask: { blur: false } },
  drawer: { mask: { blur: false } }
}

// Static feedback APIs are also used outside React components (showErrors).
ConfigProvider.config({
  holderRender: (children) => (
    <ConfigProvider {...antConfig}>{children}</ConfigProvider>
  )
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //   refetchOnWindowFocus: false,
      retry: false
    }
  }
})

const App: FunctionComponent = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider {...antConfig}>
          <Router>
            <MasterLayout />
          </Router>
        </ConfigProvider>
      </QueryClientProvider>
    </Provider>
  )
}

export default App
